import { AsyncThunkPayloadCreator } from '@reduxjs/toolkit'
import { cloneDeep, isEqual } from 'lodash'

import { RejectValue } from './types'

export interface CashingData {
  params: any
  result: any
  timeRequest?: number
}

const cacheActions = new WeakMap<any, CashingData>()

export const actionCaching =
  <Returned, ThunkArg>(
    promise: AsyncThunkPayloadCreator<Returned, ThunkArg, RejectValue>,
    isCashing: boolean | undefined,
    cash?: number,
  ) =>
  async (...args: Parameters<typeof promise>) => {
    if (!isCashing) {
      return promise(...args)
    }

    const currentTime = Date.now()
    const cashingData = cacheActions.get(promise)

    if (
      cashingData &&
      isEqual(cashingData.params, args[0]) &&
      (!cash || (cashingData.timeRequest || currentTime) + cash > currentTime)
    ) {
      return Promise.resolve(cloneDeep(cashingData.result))
    }

    try {
      const result = await promise(...args)

      cacheActions.set(promise, {
        params: args[0],
        result: cloneDeep(result),
        timeRequest: currentTime,
      })

      return result
    } catch (error) {
      cacheActions.delete(promise)
      throw error
    }
  }
